<template>
  <div class="contact-content">
    <defaultHeader :navIndex="3"></defaultHeader>
    <mobileHeader></mobileHeader>
    <boxTitle :imgUrl="imgUrl1" :imgTitle="imgTitle"></boxTitle>
    <!-- <div class="common-content">
      <div class="top-banner">
        <div class="img-bg" :style="{backgroundImage: 'url(' + imgUrl + ')'}">
          <div class="top-banner-text">自然与魔术的碰撞</div>
        </div>
      </div>
    </div> -->

    <div class="contact-us">
      <div class="contact-us-div">
        <div class="contact-us-top">
          <div class="title">
            <div>我们用心去聆听您的问题</div>
          </div>
          <div class="line">
            <div></div>
          </div>
          <div class="box-info">
            <div>
              <p>欢迎拨打电话客服热线，24小时全天有效。</p>
              <p>我们会对您的问题或留言进行备案，并通过电子邮件等联系方式通知您。</p>
            </div>
          </div>
        </div>
        <div class="contact-us-center">
          <textarea placeholder="留言内容" v-model="text"></textarea>
          <input placeholder="留言联系人" v-model="userName" />
          <input placeholder="联系电话" v-model="phone" />
          <div class="div">
            <input placeholder="验证码" v-model="code" />
            <validCode :value.sync="validCode"></validCode>
          </div>
        </div>
        <div class="save">
          <div class="reset" @click="onClear">重置</div>
          <div @click="onSave">提交</div>
        </div>
        <div class="company-map">
          <baidu-map class="company-map-info" :center="center" :zoom="zoom" @ready="handler" @click="getClickInfo"
            :scroll-wheel-zoom='true'>
          </baidu-map>
        </div>

        <div class="map-box" v-html="detail"></div>
      </div>
    </div>
    <div class="contact-us-bottom">
      <div class="contact-us-bottom-item" ref="obtainOne"
        :class="boxOne == true ? 'contact-us-bottom-item-opcity' : ''">
        <div>加入我们</div>
        <p>我们正在寻找更多才学横溢、有梦想的伙伴，和我们一起做充满激情的事情。</p>
        <span>→</span>
      </div>
      <div class="line">
        <div></div>
      </div>
      <div class="contact-us-bottom-item" ref="obtainTwo"
        :class="boxTwo == true ? 'contact-us-bottom-item-opcity' : ''">
        <div>解决方案</div>
        <p>深耕行业十余年，专业从事室内外设计施工一体化企业，专业提供装饰工程解决方案。</p>
        <span>→</span>
      </div>
      <div class="line">
        <div></div>
      </div>
      <div class="contact-us-bottom-item" ref="obtainThree"
        :class="boxThree == true ? 'contact-us-bottom-item-opcity' : ''">
        <div>联系我们</div>
        <p>您的反馈对我们来说很重要，我们非常希望听到您的建议或想法。</p>
        <span>→</span>
      </div>
    </div>
    <goBack></goBack>
    <defaulFooter></defaulFooter>
  </div>
</template>
<script>
  import {
    menuList,
    articleDetail,
    message
  } from '@/api/xx-index'
  import {
    infoList
  } from '@/api/index'
  import defaultHeader from '../components/defaultheader.vue'
  import mobileHeader from '../components/mobileheader.vue'
  import defaulFooter from '../components/defaulfooter.vue'
  import validCode from '../components/code.vue'
  import goBack from '@/components/goBack'
  import boxTitle from '../components/boxTitle.vue'
  const img = require('../../static/images/img12.jpg')
  export default {
    components: {
      defaultHeader,
      defaulFooter,
      validCode,
      mobileHeader,
      goBack,
      boxTitle
    },
    name: 'contactUs',
    data() {
      return {
        boxOne: false,
        boxTwo: false,
        boxThree: false,
        imgUrl: img,
        menuIds: '',
        listNav: [],
        articleId: '',
        detail: '',
        userName: '',
        text: '',
        phone: '',
        code: '',
        imgUrl1: '',
        imgTitle: '',
        center: {
          lng: 0,
          lat: 0
        }, //lng代表纬度 lat代表经度
        zoom: 19
      }
    },
    created() {
      //公司基本信息数据
      infoList({
        deptId: 112
      }).then(res => {
        // console.log('公司基本信息', res)
        document.title = '联系我们-' + res.companyName + '-' + res.websiteDesc
        this.center.lng = res.longitude
        this.center.lat = res.latitude
        console.log(res)
      })
    },
    mounted() {
      // 滚动条的获取
      window.addEventListener('scroll', this.onScroll, true)

      this.menuIds = window.location.href.split('=')[1]
      menuList({
        deptId: 112
      }).then(res => {
        console.log(res)
        this.listNav = res
        for (let i = 0; i < this.listNav.length; i++) {
          if (this.listNav[i].id == this.menuIds) {
            console.log(this.listNav[i])
            this.articleId = this.listNav[i].template.articleId
            this.imgUrl1 = this.listNav[i].menuBgimg
            this.imgTitle = this.listNav[i].menuBgimgTitle
            console.log(this.articleId)
          }
        }
        this.getDetail(this.articleId)
      })
    },
    methods: {
      getScrollTop() {
        var scrollTop = 0
        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop
        } else if (document.body) {
          scrollTop = document.body.scrollTop
        }
        // console.log('这是滚动距离', scrollTop)
        return scrollTop
      },
      onScroll() {
        if (this.getScrollTop() >= 1150) {
          this.boxOne = true
        }
        if (this.getScrollTop() >= 1300) {
          this.boxTwo = true
        }
        if (this.getScrollTop() >= 1400) {
          this.boxThree = true
        }
      },
      getDetail(articleId) {
        articleDetail({
          articleId: articleId
        }).then(res => {
          console.log(res)
          this.detail = res.articleValue
        })
      },
      //重置
      onClear() {
        this.userName = ''
        this.text = ''
        this.phone = ''
        this.code = ''
      },
      //留言
      onSave() {
        let param = {
          deptId: 112,
          contacts: this.userName,
          content: this.text,
          phone: this.phone
        }
        if (this.text == '') {
          alert('请输入内容')
          return
        }
        if (this.userName == '') {
          alert('请输入联系人')
          return
        }
        let reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
        if (this.phone == '') {
          alert('请输入手机号码')
          return
        } else if (!reg.test(this.phone)) {
          alert('手机格式不正确')
          return
        }

        if (this.validCode == '') {
          alert('请输入验证码')
          return
        } else if (this.validCode != this.code) {
          alert('验证码输入错误')
          return
        }
        message(param).then(res => {
          console.log(res)
          if (res == '新增成功') {
            alert('新增成功')
            this.userName = ''
            this.text = ''
            this.phone = ''
            this.code = ''
          }
        })
      },
      //地图
      handler({
        BMap,
        map
      }) {
        var point = new BMap.Point(this.center.lng, this.center.lat)
        map.centerAndZoom(point, 19)
        var marker = new BMap.Marker(point) // 创建标注
        map.addOverlay(marker) // 将标注添加到地图中
        var circle = new BMap.Circle(point, 1, {
          strokeColor: 'Red',
          strokeWeight: 1,
          strokeOpacity: 1,
          Color: 'Red',
          fillColor: '#f03'
        })
        map.addOverlay(circle)
      },
      getClickInfo(e) {
        console.log(e.point.lng)
        console.log(e.point.lat)
        this.center.lng = e.point.lng
        this.center.lat = e.point.lat
      }
    }
  }
</script>

<style>
  a {
    color: #ffffff !important;
    text-decoration: none;
  }
</style>
